export const IS_ALLOCATING_INVENTORY = {
  key: 'IS_ALLOCATING_INVENTORY',
  initialState: false,
};

export const currentCostReviewTrackingId = (initialTrackingId) => ({
  key: 'CURRENT_COST_REVIEW_TRACKING_ID',
  initialState: initialTrackingId,
});

export const workflowDataState = (initialState) => ({
  key: 'WORKFLOW_DATA',
  initialState,
});

export const cheapestRateState = (fulfillmentPlanId, initialState) => ({
  key: `CHEAPEST_RATE_${fulfillmentPlanId}`,
  initialState,
});

export const freightQuoteState = (fulfillmentPlanId, initialState) => ({
  key: `FREIGHT_QUOTE_${fulfillmentPlanId}`,
  initialState,
});
